import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { setUserGamingStyle } from "state/actions";
import { useRouter } from "apis/history";

import { useQuery } from "styles/breakpoints";
import { tabletLarge, tablet } from "styles/breakpoints";

import {
  ContainerMedium,
  FlexWrapper,
  GridWrapper,
  H1,
  H4,
  Image,
  Paragraph,
  PrimaryButton,
  TextBase,
} from "components";
import { FooterLanding } from "layouts/banners/FooterLanding";

import { blue, orange } from "styles/colors";

export const PlayEverywhere = () => {
  const { isTablet, isTabletLarge } = useQuery();
  const dispatch = useDispatch();
  const { goToQuiz } = useRouter();

  const handleGamingStyleSelection = (style: string) => {
    dispatch(setUserGamingStyle(style));
    goToQuiz();
  };

  return (
    <SectionFlexWrapper
      justifyContent={isTablet ? "flex-start" : "center"}
      padding={isTablet ? "5.5rem 1rem 0 1rem" : "4.5rem 0 0 0"}
      flexDirection='column'
    >
      <ContainerMedium
        margin={isTablet ? "0" : "0 auto"}
        padding={isTablet ? "1rem auto 0 auto" : "0 0 6rem 0"}
      >
        <FlexWrapper
          alignItems={isTabletLarge ? "center" : "flex-end"}
          flexDirection={isTabletLarge ? "column-reverse" : "row"}
          justifyContent={isTabletLarge ? "flex-start" : "space-between"}
        >
          <FlexWrapperStyled flexDirection='column'>
            <H1
              margin={isTablet ? "1.5rem 0 0.5rem 0" : "0 0 0.5rem 0"}
              textAlign={isTabletLarge ? "center" : "start"}
            >
              Play Everywhere!
            </H1>
            <H4 textAlign={isTabletLarge ? "center" : "start"}>
              Exclusive games. Next gen performance.
            </H4>
            <ParagraphStyled
              margin={isTablet ? "1.5rem auto" : "2.5rem 0"}
              textAlign={isTabletLarge ? "center" : "start"}
            >
              Play Everywhere gaming service can offer anything for casual and
              hardcore gamer. From family friendly experience to 4k 120FPS HDR
              gaming. Answer the quiz, check what is best for you and we will
              offer you a gaming service plan you can't refuse.
            </ParagraphStyled>
            <TextBase
              fontSize={isTablet ? "0.81rem" : "0.88rem;"}
              fontWeight={700}
              textAlign={isTabletLarge ? "center" : "start"}
            >
              Start by selecting your gaming type
            </TextBase>
            <GridWrapper columns={2} gap='1rem' margin='1rem 0'>
              <PrimaryButton
                background={blue}
                minWidth='100%'
                borderRadius='0.5rem'
                onClick={() => handleGamingStyleSelection("casual")}
              >
                Casual
              </PrimaryButton>
              <PrimaryButton
                background={orange}
                minWidth='100%'
                borderRadius='0.5rem'
                onClick={() => handleGamingStyleSelection("hardcore")}
              >
                Hardcore
              </PrimaryButton>
            </GridWrapper>
          </FlexWrapperStyled>
          <FlexWrapperStyled justifyContent='center'>
            <Image
              src='main_logo'
              margin='0 auto'
              width={isTabletLarge ? "73%" : "80%"}
            />
          </FlexWrapperStyled>
        </FlexWrapper>
      </ContainerMedium>
      <FooterLanding />
    </SectionFlexWrapper>
  );
};

const SectionFlexWrapper = styled(FlexWrapper)`
  position: relative;
  height: 100vh;

  @media ${tablet} {
    height: 100%;
  }
`;

const FlexWrapperStyled = styled(FlexWrapper)`
  max-width: 50%;

  @media ${tabletLarge} {
    min-width: 100%;
  }
`;

const ParagraphStyled = styled(Paragraph)`
  max-width: 30.38rem;
`;
